/**
 * Digitouch custom JS
 * Gestisce la sostituzione del prezzo €0,00 con "Prezzo su richiesta"
 * nei prodotti correlati (app Tipo Related Products).
 */
(function () {
  'use strict';

  var PRIVATE_DEAL_TEXT = 'Prezzo su richiesta';
  var debounceTimer = null;

  function handleZeroPriceProducts() {
    var products = document.querySelectorAll('.ga-product');

    products.forEach(function (product) {
      var priceEl = product.querySelector('.ga-product_price');
      if (!priceEl || priceEl.hasAttribute('data-price-handled')) return;

      var shouldReplace = false;

      // Controlla data-price sulla variante selezionata
      var selectedOption = product.querySelector(
        '.ga-product_variant_select option[selected]'
      );
      if (!selectedOption) {
        selectedOption = product.querySelector(
          '.ga-product_variant_select option:first-child'
        );
      }

      if (selectedOption) {
        var dataPrice = selectedOption.getAttribute('data-price');
        if (dataPrice !== null && parseFloat(dataPrice) === 0) {
          shouldReplace = true;
        }
      }

      // Fallback: controlla il testo del prezzo visualizzato
      if (!shouldReplace) {
        var priceText = priceEl.textContent.trim();
        if (/^[A-Z€$£]*\s*0[,.]00\s*$/.test(priceText)) {
          shouldReplace = true;
        }
      }

      if (shouldReplace) {
        priceEl.textContent = PRIVATE_DEAL_TEXT;
        priceEl.classList.add('price-is-private-deal');
        priceEl.classList.remove('money');
        priceEl.setAttribute('data-price-handled', 'true');
      }
    });
  }

  function debouncedHandle() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(handleZeroPriceProducts, 100);
  }

  // Esegui al DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', debouncedHandle);
  } else {
    debouncedHandle();
  }

  // MutationObserver per contenuti caricati dinamicamente dall'app
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        debouncedHandle();
        return;
      }
    }
  });

  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
